import * as Yup from 'yup';

export const RegistroDeudaHistorialValues = (deuda_id) => {
    return {
        initialValues: {
            deuda_id: deuda_id,
            metodo_pago: 'efectivo',
            monto_efectivo: 0,
            monto_transferencia: 0,
            cantidad: 0,
            obs: '',
        },
        fieldsValidation: Yup.object().shape({
            // cantidad: NumberIntegerRequired,            
        }),
        fields: [
            {
                label: 'Método de pago',
                name: 'metodo_pago',
                type: 'select',
                required: true,
                options: [
                    {
                        label: 'Efectivo',
                        value: 'efectivo'
                    },
                    {
                        label: 'Transferencia',
                        value: 'transferencia'
                    },
                    {
                        label: 'Cheque',
                        value: 'cheque'
                    },
                    {
                        label: 'Combinado E/T',
                        value: 'combinado'
                    },
                ],
            },
            {
                label: 'Monto efectivo',
                name: 'monto_efectivo',
                type: 'groupnumber',
                subData: 'Bs.',
                disabled: false,
                required: true,
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    if (['efectivo', 'combinado'].includes(values.metodo_pago))
                        setAditionalClass('')
                    else
                        setAditionalClass('hidden')
                },
                fieldDependency: 'metodo_pago',
                highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Monto transferencia',
                name: 'monto_transferencia',
                type: 'groupnumber',
                subData: 'Bs.',
                disabled: false,
                required: true,
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    if (['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago))
                        setAditionalClass('')
                    else
                        setAditionalClass('hidden')
                },
                fieldDependency: 'metodo_pago',
                highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                type: 'divider'
            },
            {
                label: 'Observaciones',
                name: 'obs',
                type: 'textArea',
                required: false,
                placeholder: 'Observaciones...',
                autoFocus: false
            },
        ]
    }
}

export const EditarObsDeudaHistorialValues = (deudaHistorialId, obs) => {
    return {
        initialValues: {
            deudaHistorialId: deudaHistorialId,
            obs: obs || '',
        },
        fieldsValidation: Yup.object().shape({
            // cantidad: NumberIntegerRequired,            
        }),
        fields: [
            {
                label: 'Observaciones',
                name: 'obs',
                type: 'textArea',
                required: false,
                placeholder: 'Observaciones...',
                autoFocus: false
            },
        ]
    }
}

export const DeleteValues = (data) => {
    return {
        initialValues: {
        },
        fieldsValidation: Yup.object().shape({
        }),
        fields: []
    }
}